module.exports = __webpack_public_path__ + "static/media/cartography.43eb38be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/estrategas/tools/cartography.svg
// module id = 610
// module chunks = 0